import { OrderPlanningRowAction, OrderPlanningRowActionProps, ReasonMap } from "./OrderPlanningRowAction";
import { Button, TableRow } from "@mcleod/components";
import { ActionPermission, Api, ModelRow, StringUtil } from "@mcleod/core";
import { SendLoad } from "../../asset/SendLoad";
import { LMECompanySettings } from "@mcleod/general";
import { RowDispatchControlFields } from "@mcleod/general/src/models/autogen/AutogenModelDispatchControl";
import { OrderMultiSelectErrorModal } from "@mcleod/general/src/OrderMultiSelectErrorModal";
import { CommonDialogs } from "@mcleod/common";

export class RowActionZmit extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonZmit;
    }

    override getButtonId(): string {
        return "buttonZmit";
    }

    override getAdditionalProps() {
        return this.getFindNearAfterSlideoutProp();
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["equip_group_id", "movement_id"];
    }

    override getMaxSelections(): keyof RowDispatchControlFields {
        return "max_send_load_selections";
    }

    override getMultiSelectPermission(): ActionPermission {
        return ActionPermission.ACTION_MULTISELECT_SEND_LOAD;
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        const modelRow = selectedRows[0];
        if (selectedRows.length > 1) {
            this.getButton().caption = "Send Preplan";
            if (selectedRows.some(r => r.isNull("tractor") && r.isNull("driver1_id"))) {
                this.addReason(reasonMap, "no_equipment", "Cannot send load information for multiple moves if they are unassigned.");
            }
        } else {
            this.getButton().caption = "Send Load";
        }
        if ("D" === modelRow?.get("move_status")) {
            this.addReason(reasonMap, "move_status", "Cannot send a load that is already delivered.");
        }
    }

    override async execute(props: OrderPlanningRowActionProps) {
        const selectedRows = props.selectedRows;
        const modelRow = selectedRows[0]?.data as ModelRow; // will be changed to multi-select later
        if (modelRow == null)
            return;

        if (selectedRows.length > 1) {
            if (await CommonDialogs.showYesNo(`Send load information for ${selectedRows.length} selected loads?`)) {
                this.sendLoads(selectedRows);
            }
        } else {
            this.getButton().busy = true;
            SendLoad.showSlideout({
                equipmentGroupId: modelRow.get("equip_group_id"),
                movementId: modelRow.get("movement_id"),
            }, { doAfterSlideOut: props.afterSlideout});
            this.getButton().busy = false;
        }
    }

    async sendLoads(selectedRows: TableRow[]) {
            const result = await Api.post("lme/dispatch/asset/zmit-load/batch", {
                keys: selectedRows.map(row => ({ movement_id: row.data.get("movement_id") })),
                data: { preplan: true }
            });
            this.getButton().makeBusyWhile(result);
            const updated = result.data.filter(result => StringUtil.isEmptyString(result.message));

            const failedResults = result.data.filter(result => !StringUtil.isEmptyString(result.message) && result.retry);
            const failedRows = failedResults.map(result => {
                const row = selectedRows.find(row => row.data.getString("movement_id") === result.keys.movement_id)
                row.data.set("error", result.message);
                return row;
            });

            const erroredResults = result.data.filter(result => !StringUtil.isEmptyString(result.message) && !result.retry);
            const erroredRows = erroredResults.map(result => {
                const row = selectedRows.find(row => row.data.getString("movement_id") === result.keys.movement_id)
                const modelRow = row.data.createBasicCopy();
                modelRow.set("error", result.message);
                return modelRow;
            });

            const retryAction = (selectedErrorRows: TableRow[]) => this.sendLoads(selectedErrorRows);
            OrderMultiSelectErrorModal.showModal(failedRows, erroredRows, updated.length, "Send Loads", "Retry", retryAction, undefined, true);
    }

    static override canShowAction(): boolean {
        return LMECompanySettings.get().mobile_comm_licensed_active
    }
}
